/* Cery Shop — carosello showcase (Offerte / Prodotti del momento)
   Definito globalmente così i custom element si attivano sempre,
   anche quando l'editor Shopify re-inserisce la sezione. */
(() => {
  if (customElements.get('showcase-carousel')) return;

  class ShowcaseCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cs__track');
      if (!this.track) return;
      this.section = this.closest('.cs');
      this.playing = this.dataset.autoplay === 'true';
      this.speed = (parseInt(this.dataset.speed, 10) || 4) * 1000;
      this.timer = null;

      if (this.section) {
        this.section.querySelectorAll('.cs__arrow').forEach((b) => {
          b.addEventListener('click', (e) => {
            e.preventDefault();
            this.step(b.getAttribute('data-cs-dir') === 'next' ? 1 : -1);
            this.restart();
          });
        });
      }

      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach((e) =>
        this.addEventListener(e, () => this.stop(), { passive: true })
      );
      ['mouseleave', 'focusout', 'touchend'].forEach((e) =>
        this.addEventListener(e, () => this.start(), { passive: true })
      );

      this.enableDrag();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.playing = false;
      this.start();
    }

    disconnectedCallback() { this.stop(); }

    get stepSize() {
      const card = this.track.querySelector('.pc');
      if (!card) return this.track.clientWidth;
      const cs = getComputedStyle(this.track);
      const gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    step(dir) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      let target = this.track.scrollLeft + dir * this.stepSize;
      if (dir > 0 && this.track.scrollLeft >= max - 2) target = 0;
      if (dir < 0 && this.track.scrollLeft <= 2) target = max;
      this.track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    start() {
      if (!this.playing) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 2) return;
      this.stop();
      this.timer = setInterval(() => this.step(1), this.speed);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }

    enableDrag() {
      let down = false, x0 = 0, left0 = 0, moved = false;
      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        down = true; moved = false; x0 = e.clientX; left0 = this.track.scrollLeft;
        this.track.classList.add('is-dragging');
      });
      this.track.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - x0;
        if (Math.abs(dx) > 4) moved = true;
        this.track.scrollLeft = left0 - dx;
      });
      const up = () => { down = false; this.track.classList.remove('is-dragging'); };
      this.track.addEventListener('pointerup', up);
      this.track.addEventListener('pointerleave', up);
      this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
    }
  }

  customElements.define('showcase-carousel', ShowcaseCarousel);
})();
